import { connect } from 'react-redux';
import App from './components/App';
import { loadFilterProfiles, loadFilters } from '../../redux/actions/filters';
import { logout } from '../../redux/actions/auth';
import { loadUser, setWebsocketConnection } from '../../redux/actions/user';
import {
  saveMergeAPIExploreRecipeForwardA,
  resetRecipeStatus,
  saveBreadCrumbs,
  updateHistoryQuery,
  addNewHistoryQuery,
} from '../../redux/actions/ioc';

import { removeNotification } from '../../redux/actions/notifications';

const mapStateToProps = (state, props) => ({
  user: state.user.user,
  websocketConnectionStatus: state.user.websocketConnectionStatus,
  userStatus: state.user.status,
  auth: state.auth,
  refresh: state.refresh,
  leftMenuSideBarCollapsed: state.sidebar.leftMenuSideBarCollapsed,
  notification: state.notification,
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
  mySubscriptionLimit: state.user.mySubscriptionLimit,
  mySubscriptionLimitStatus: state.user.mySubscriptionLimitStatus,
});

const mapDispatchToProps = {
  saveMergeAPIExploreRecipeForwardA,
  resetRecipeStatus,
  loadFilters,
  loadFilterProfiles,
  logout,
  loadUser,
  setWebsocketConnection,
  removeNotification,
  saveBreadCrumbs,
  updateHistoryQuery,
  addNewHistoryQuery,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
